"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInvoiceType = exports.OrganizationIdentifierScheme = void 0;
var OrganizationIdentifierScheme;
(function (OrganizationIdentifierScheme) {
    OrganizationIdentifierScheme["DK_CVR"] = "DK:CVR";
    OrganizationIdentifierScheme["GLN"] = "GLN";
})(OrganizationIdentifierScheme || (exports.OrganizationIdentifierScheme = OrganizationIdentifierScheme = {}));
var EInvoiceType;
(function (EInvoiceType) {
    EInvoiceType["Invoice"] = "INVOICE";
    EInvoiceType["Reminder"] = "REMINDER";
    EInvoiceType["Creditnote"] = "CREDITNOTE";
})(EInvoiceType || (exports.EInvoiceType = EInvoiceType = {}));
//# sourceMappingURL=index.js.map